import './route-popup.less'
import React from 'react';
import classnames from 'classnames'
import Component from './route-component';
import Enhance from '../core/enhance';
import tools from '../libs/tools';
import Router from './router'
import $event from "../decorators/$event";

/**
 *
 */
class RoutePopup extends Component {
    state = {
        uuid: tools.uuid()
    };

    constructor(props) {
        super(props);

        if (this.props.uuid) {
            this.state.uuid = this.props.uuid
        }
    }

    /**
     *
     * @return {*}
     */
    render() {
        let {location} = window.appHistory;

        let show = false;
        if (location && location.state && location.state.popup === this.state.uuid) {
            show = true;
        }
        //if (show) {
        //    $('body').addClass('router-popup');
        //} else {
        //    $('body').removeClass('router-popup');
        //}

        let {placement, size, offset} = this.props;
        let style = {};
        switch (placement) {
            case 'bottom':
                style = {
                    height: size || '50%',
                    top: offset || '50%'
                };
                break;
            case 'left':
                style = {
                    width: size || '50%',
                    right: offset || '50%'
                };
                break;
        }

        return (
            <div className={classnames('c-route-popup', this.props.className)}>
                <div
                    ref="popup"
                    className={classnames("c-route-popup-modal c-route-popup-modal-" + placement, show ? 'c-route-popup-modal-in' : '')}
                    style={{
                        display: 'block',
                        ...style
                    }}
                    onClick={(e) => {
                        if (show) {
                            Router.pop(-1);
                        }
                    }}
                >
                    <div
                        onClick={(e) => {
                            e.stopPropagation();
                            return false;
                        }}
                    >
                        {this.props.children}
                    </div>
                </div>
                <div
                    ref="overlay"
                    className={classnames("c-route-popup-overlay", show ? 'c-route-popup-overlay-visible' : '')}

                />
            </div>
        );
    }

    /**
     *
     */
    show() {
        let {uuid} = this.state;
        let {pathname, search, hash} = window.location;
        Router.push(pathname + search + hash, {popup: uuid, rollback: true}, true);
        // 当前记录中覆盖state
    }

    /**
     *
     * @param data
     * @param type
     */
    @$event('Router.listen')
    handlerRouterListen = (data, type) => {
        this.forceUpdate();
    }

}

Enhance(RoutePopup, {
    defaultProps: {
        size: '100%',
        offset: '0',
        placement: 'bottom'
    }
}, 'RoutePopup');
export default RoutePopup;
